import { render, staticRenderFns } from "./error_404.vue?vue&type=template&id=9b8a41dc&scoped=true&lang=html&"
import script from "./error_404.vue?vue&type=script&lang=js&"
export * from "./error_404.vue?vue&type=script&lang=js&"
import style0 from "./error_404.vue?vue&type=style&index=0&id=9b8a41dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a41dc",
  null
  
)

export default component.exports